<template>
  <div class="bottom-wrap">
    <div class="bottom">
      <div class="bottom-top">
        <div class="bottom-top1">
          <div style="width:100%;height:30px"></div>
          <div class="bottom-top1-logo"></div>
          <div class="bottom-top1-add">
            <div class="bottom-top1-add1">地址：北京市海淀区阜成路33号</div>
            <div class="bottom-top1-add2">邮编：100048</div>
          </div>
        </div>
        <!-- <div class="bottom-top2">
          <div class="bottom-top2-title">友情链接 ：</div>
          <div class="bottom-top2-links">
            <div>北京市财局</div>
            <div class="bottom-top2-links-line"></div>
            <div>北京市教育委员会</div>
            <div class="bottom-top2-links-line"></div>
            <div>京华云采</div>
          </div>
        </div> -->
      </div>
      <div class="bottom-bottom">
        <div class="bottom-bottom1">版权所有：北京工商大学国有资产管理处</div>
        <!-- <div class="bottom-bottom2"></div>
        <div class="bottom-bottom1">贵公网安备 520103020xxxxx号</div> -->
        <div class="bottom-bottom1">技术支持：北京久其软件股份有限公司</div>
        <div class="bottom-bottom1">邮箱：jiuqi@jiuqi.com.cn</div>
        <div class="bottom-bottom1">电话：400-119-9797</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components:{
  }
}
</script>

<style lang="less" scoped>
.bottom-wrap{
  width: 100%;
  height: 211px;
  background: #F1F4F7;
  .bottom{
    width: 1200px;
    margin: 0 auto;
  }
  .bottom-top{
    width: 100%;
    height: 112px;
    border-bottom: 1px solid #E5E5E5;;
  }
  .bottom-top1{
    width: 500px;
    margin: 0 auto;
  }
  .bottom-top1-logo{
    width: 239px;
    height: 52px;
    background: url('../../../static/statistics/底部logo@2x.webp');
    background-size: 239px 52px;
    margin-right: 21px;
    float: left;
  }
  .bottom-top1-add{
    float: left;
    margin-top: 3px;
  }
  .bottom-top1-add1{
    height: 24px;
    font-family: MicrosoftYaHei;
    font-size: 12px;
    color: #424242;
    line-height: 24px;
  }
  .bottom-top1-add2{
    height: 24px;
    font-family: MicrosoftYaHei;
    font-size: 12px;
    color: #424242;
    line-height: 24px
  }
  .bottom-top2{
    float: right;
    margin-top: 34px;
  }
  .bottom-top2-title{
    height: 20px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 14px;
    color: #424242;
    line-height: 20px;
    margin-bottom: 4px;
  }
  .bottom-top2-links div{
    float: left;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #424242;
    line-height: 20px;
  }
  .bottom-top2-links .bottom-top2-links-line{
    width: 1px;
    height: 15px;
    opacity: 0.65;
    background: #B8B8B8;
    margin-left: 24px;
    margin-right: 24px;
  }
  .bottom-bottom{
    width: 800px;
    margin: 0 auto;
  }
  .bottom-bottom1{
    float: left;
    margin-right: 20px;
    height: 28px;
    font-family: MicrosoftYaHei;
    font-size: 12px;
    color: #424242;
    line-height: 28px;
    margin-top: 30px;
  }
  .bottom-bottom2{
    float: left;
    margin-right: 8px;
    width: 16px;
    height: 16px;
    background: url('../../../static/statistics/公安@2x.webp');
    background-size: 16px 16px;
    margin-top: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Statistics/bottom.vue